import { ReportSubscription } from "@/model/data/reportSubscription/ReportSubscription";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";

const ENDPOINT = "/report_subscription/send_now";

export class SendReportNowCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    rs: ReportSubscription;

    constructor(rs: ReportSubscription) {
        super();
        this.rs = rs;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand({ ReportSubscription: this.rs });
        return new ServiceResponseData(res);
    }
}
